// @noflow
import './styles.css';

import { FormattedMessage } from 'react-intl';
import { messages } from '~/core/constants/time-units';
import PropTypes from 'prop-types';
import * as React from 'react';

const NowTickPropTypes = {
    style: PropTypes.shape({
        right: PropTypes.string.isRequired
    })
};

const NowTick = ({ style }) => {
    return (
        <div className="logs-timeline-component__now" style={style}>
            <span className="logs-timeline-component__now-pipe">|</span>
            <div className="logs-timeline-component__now-label">
                <FormattedMessage {...messages.now} />
            </div>
        </div>
    );
};

NowTick.propTypes = NowTickPropTypes;
export default NowTick;



// WEBPACK FOOTER //
// ./src/components/widgets/logs-timeline/timeline/now/index.js